module.exports = __webpack_public_path__ + "static/media/file-edit.f58c5bcf.svg";